import React, { useState, useEffect } from "react";
import bgImage from "../Images/testimonials.jpg";

const testimonials = [
  {
    quote:
      "We were nervous about traveling with two little kids to Dubai, but Aurah Leisure made it so smooth. They booked us a hotel right next to kid-friendly attractions which made it so convenient for us to go around. When our flight got delayed, the team immediately rescheduled our airport pickup without us even asking. It really felt like someone had our back the whole way.",
    author: "Family Vacation (Dubai Trip)",
  },
  {
    quote:
      "Aurah Leisure planned our Maldives honeymoon and honestly, it was magical. They arranged a surprise candlelight dinner on the beach and even got the resort to bake us a ‘Just Married’ cake! The best part — when our connecting flight was rescheduled last minute, the team handled everything while we just sipped cocktails by the pool. Zero stress, only memories.",
    author: "Honeymoon Couple (Maldives)",
  },
  {
    quote:
      "Manage travel for a mid-size company, and Aurah Leisure has been a lifesaver. They’ve handled everything from last-minute visa requests to rerouting flights when meetings got extended. Their response time is fast — I once called them at midnight about a boarding issue, and they solved it before my colleague even reached the counter. That kind of reliability is rare.",
    author: "⁠Corporate Travel Manager",
  },
  {
    quote:
      "I usually book my business trips with Aurah but this time I thought let me book my Leisure trip too. I travelled to Europe and they suggested small boutique hotels I’d never have found online within my budget and even booked the tours while I was on my trip. I just messaged them what I wanted a day or two prior and bookings were done. Having that kind of support while traveling alone was such a relief.",
    author: "⁠Frequent Corporate Traveler",
  },
  {
    quote:
      "Our Bali trip with Aurah Leisure was full of thoughtful touches — private villa stays, a sunset cruise, and even a driver who knew all the best local food spots. We loved that it wasn’t just a cookie-cutter itinerary. It felt like someone who knows us planned it.",
    author: "Couple’s Luxury Getaway (Bali)",
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  // Desktop arrows (instant change)
  const handleNextDesktop = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrevDesktop = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Mobile automatic transition every 5 seconds
  useEffect(() => {
    const isMobile = window.innerWidth < 640;
    if (!isMobile) return; // Only for mobile

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center flex items-center justify-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/55 backdrop-blur-sm z-0" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-6xl px-4 py-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#FAF6F1] mb-6 sm:mb-8 text-center font-sans">
          What Our Travellers Have To Say
        </h2>

        <div className="relative w-full flex items-center justify-center">
          {/* Left Arrow - desktop only */}
          <button
            onClick={handlePrevDesktop}
            className="hidden sm:block absolute left-0 text-white text-4xl sm:text-6xl px-4 sm:px-6"
            aria-label="Previous Testimonial"
          >
            <span className="block transform rotate-180">➤</span>
          </button>

          {/* Testimonial Box */}
          <div
            className="bg-white rounded-2xl sm:rounded-3xl px-6 sm:px-12 py-8 sm:py-10 shadow-xl text-center max-w-3xl border border-gray-200 transition-all duration-500"
            key={current}
          >
            <p className="text-base sm:text-lg italic text-gray-800 mb-4">
              “{testimonials[current].quote}”
            </p>
            <p className="text-sm sm:text-md font-semibold text-[#007B7F]">
              — {testimonials[current].author}
            </p>
          </div>

          {/* Right Arrow - desktop only */}
          <button
            onClick={handleNextDesktop}
            className="hidden sm:block absolute right-0 text-white text-4xl sm:text-6xl px-4 sm:px-6"
            aria-label="Next Testimonial"
          >
            <span className="block">➤</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
